import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { MessageActionsGroupFragmentDoc } from './messageActionsGroup';
export type MessengerTemplateCategoryFragment = { __typename?: 'TemplateCategory', id: string, channels: Array<Types.TemplateChannelEnum>, title: string, templatesGroups: Array<{ __typename?: 'ManagerTemplateGroupType', constantName?: string | null, direction: Types.TemplateDirectionEnum, id: string, name?: string | null, messageActionsGroup?: { __typename?: 'MessageActionsGroup', createdAt: string, id: string, name: string, templateType?: Types.TemplateTypeEnum | null, updatedAt: string, actions: Array<{ __typename?: 'MessageAction', action: string, createdAt: string, description?: string | null, groupId: string, id: string, position: number, updatedAt: string, labels: { __typename?: 'LabelsCollection', cs?: string | null, da?: string | null, de?: string | null, en?: string | null, es?: string | null, fi?: string | null, fr?: string | null, it?: string | null, nb?: string | null, nl?: string | null, pl?: string | null, ptPt?: string | null, sv?: string | null, tr?: string | null } }> } | null, templates: Array<{ __typename?: 'Template', id: string, locale: Types.TemplateLocaleEnum }> }> };

export const MessengerTemplateCategoryFragmentDoc = gql`
    fragment messengerTemplateCategory on TemplateCategory {
  id
  channels
  title
  templatesGroups {
    constantName
    direction
    id
    messageActionsGroup {
      ...messageActionsGroup
    }
    name
    templates {
      id
      locale
    }
  }
}
    ${MessageActionsGroupFragmentDoc}`;